import type { GetDebugModeResultsParams } from "../../../helpers/leads/debug";
import type {
    ConnectionDetailData,
    DebugLog,
} from "../../../pages/LeadDebugPage/LeadDebugPage.types";

export interface GetDebugModeResultsPayload {
    connectionId: string;
    params: GetDebugModeResultsParams;
}

export interface SetDebugModePayload {
    connectionId: string;
    debug_mode: 0 | 1;
}

export interface LeadDebugPagination {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
}

export interface LeadDebugState {
    connectionDetail: ConnectionDetailData | null;
    connectionLoading: boolean;
    debugLogs: DebugLog[];
    logsLoading: boolean;
    pagination: LeadDebugPagination;
    selectedLogId: number | null;
    setDebugModeLoading: boolean;
}

export const defaultPagination: LeadDebugPagination = {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
};

export const initialState: LeadDebugState = {
    connectionDetail: null,
    connectionLoading: false,
    debugLogs: [],
    logsLoading: false,
    pagination: defaultPagination,
    selectedLogId: null,
    setDebugModeLoading: false,
};
